import FormSub from "../../components/Course/FormSub";
const SubscribeCourse = () => {
    return <FormSub />
}
export default (SubscribeCourse);